
<template>
  <div class="rightpart">
    <div class="unauth" v-show="status == 0">
      已有账号?
      <span class="fontblue fontcursor ml-16" @click="link('/login')"
        >请登录</span
      >
    </div>
    <div class="auth" v-show="status != 0">
      <img
        v-if="userImg == 'undefined' || userImg == undefined"
        src="@/assets/img/default_avatar.png"
        alt
        class="rightImg"
      />
      <img v-else class="rightImg" :src="userImg" alt />
      <Dropdown trigger="click" class="ml-10 menuColor" placement="bottom">
        <div class="headright-user-drop fontcursor fontthreedark">
          {{ username }}
          <Icon type="md-arrow-dropdown" />
        </div>
        <!-- <DropdownMenu slot="list" style="width: 100px" class="menuColor w100px">
          <a @click="link('/user/account/infoIndex/info')">
            <DropdownItem>账号中心</DropdownItem>
          </a>
        </DropdownMenu> -->
        <DropdownMenu slot="list" style="width: 100px" class="menuColor w100px">
          <a @click="getInfo">
            <DropdownItem>基本信息</DropdownItem>
          </a>
        </DropdownMenu>
        <DropdownMenu slot="list" class="menuColor w100px">
          <a @click="link()">
            <DropdownItem>退出登录</DropdownItem>
          </a>
        </DropdownMenu>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import headMenu from "./head-menu.vue";
import { getLoginUrl, existLogin, getUcInfo } from "@/api/userCenter";

export default {
  name: "",
  props: {
    status: Number,
  },
  components: {
    headMenu,
  },
  data() {
    return {};
  },
  computed: {
    username() {
      let phone = this.$store.state.username;
      let tel = _Util.getPhone(phone);
      return tel;
    },
    userImg() {
      let imgUrl = this.$store.state.userImg;
      return imgUrl;
    },
  },
  created() {},
  mounted() {},
  methods: {
    getInfo() {
      getUcInfo().then((res) => {
        console.log(res, "获取用户中心信息");
        window.open(res.data.data);
      });
    },
    async link(path) {
      if (path == undefined) {
        let host = window.location.origin;
        let data = { host: host };
        const { data: res } = await existLogin(data);
        localStorage.clear();
        _Cookie.remove("adminauth");
        window.location.href = res.data;
      }
      this.$router.push({ path: path });
      window.sessionStorage.setItem("currentActive", 1);
    },
    getLoginUrl() {
      let host = window.location.origin;
      let data = { host: host };
      getLoginUrl(data).then((res) => {
        console.log(res, "res--退出login");
        window.location.href = res.data.data;
        localStorage.setItem("LOGIN_URL", res.data.data);
      });
    },
  },
};
</script>

<style lang="scss">
.rightpart {
  .unauth {
    font-size: 14px;
    color: #67799c;
    padding-right: 100px;
  }
  .auth {
    height: 100%;
    display: flex;
    align-items: center;
    .rightImg {
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }
    .ivu-dropdown {
      height: 100%;
      line-height: 64px;
      .menuColor {
        .ivu-dropdown-item {
          color: #919caf;
        }
      }
    }
  }
}
</style>
